import type { Ref } from 'vue'
import type { MarkAsReadRequest, NotificationsListResponse } from './types'
import { useQuery } from '@tanstack/vue-query'
import { computed, unref } from 'vue'
import { apiClient } from '@/shared/api'

export function fetchNotificationsRequest(params?: {
  limit?: number
  offset?: number
}): Promise<NotificationsListResponse> {
  return apiClient.get<NotificationsListResponse>('/notifications/list/', {
    params,
    silent: true,
  })
}

export function useNotificationsQuery(
  limitRef?: Ref<number | undefined>,
  offsetRef?: Ref<number | undefined>,
) {
  return useQuery({
    queryKey: computed(() => [
      'notifications',
      unref(limitRef),
      unref(offsetRef),
    ]),
    queryFn: () =>
      fetchNotificationsRequest({
        limit: unref(limitRef),
        offset: unref(offsetRef),
      }),
  })
}

export function markNotificationAsReadRequest(
  data: MarkAsReadRequest,
): Promise<unknown> {
  return apiClient.post<unknown>('/notifications/read/', data)
}
